var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M20.5,9.1V8.8c0-0.2-0.2-0.4-0.4-0.4h-7.6c-0.2,0-0.3,0.2-0.3,0.4v0.4H20.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M32.9,9.1V8.8c0-0.2-0.2-0.4-0.4-0.4H25c-0.2,0-0.4,0.2-0.4,0.4v0.4H32.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M9.3,37.2h26.4c0.2,0,0.3-0.1,0.3-0.3V9.4c0-0.2-0.1-0.3-0.3-0.3h-2.2V8.8c0-0.6-0.4-1-1-1H25 c-0.5-0.1-0.9,0.3-1,0.8c0,0.1,0,0.1,0,0.2v0.4h-2.9V8.8c0-0.6-0.4-1-1-1h-7.6c-0.5,0-0.9,0.4-0.9,0.9c0,0,0,0.1,0,0.1v0.4H9.3 C9.1,9.1,9,9.3,9,9.4c0,0,0,0,0,0V37C9,37.1,9.1,37.2,9.3,37.2z M24.6,8.8c0-0.2,0.2-0.4,0.4-0.4h7.5c0.2,0,0.4,0.2,0.4,0.4v0.4 h-8.3V8.8z M12.2,8.8c0-0.2,0.1-0.4,0.3-0.4h7.6c0.2,0,0.4,0.2,0.4,0.4v0.4h-8.3V8.8z M9.6,9.9h25.8v4.6H9.6V9.9z M9.6,15h25.8v21.6 H9.6V15z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M35.4,14.4V9.9H9.6v4.6H35.4z M14.8,13.6c-0.8,0-1.4-0.6-1.5-1.4c0-0.8,0.7-1.5,1.5-1.5 c0.8,0.1,1.4,0.7,1.4,1.5C16.2,12.9,15.6,13.6,14.8,13.6z M18.5,13.6c-0.8,0.1-1.4-0.5-1.5-1.3c0,0,0-0.1,0-0.1 c0-0.8,0.7-1.5,1.5-1.5c0.8,0.1,1.4,0.7,1.4,1.5C19.9,12.9,19.3,13.6,18.5,13.6z M22.5,14c-1,0-1.8-0.8-1.8-1.8l0,0 c0-1,0.8-1.8,1.8-1.9c1,0.1,1.8,0.9,1.9,1.9C24.3,13.2,23.5,14,22.5,14z M26.6,13.6c-0.8,0-1.4-0.6-1.5-1.4c0-0.8,0.7-1.5,1.5-1.5 s1.5,0.7,1.5,1.5C28,12.9,27.4,13.6,26.6,13.6z M30.3,13.6c-0.8,0-1.4-0.6-1.5-1.4c0-0.8,0.7-1.5,1.5-1.5c0.8,0.1,1.4,0.7,1.4,1.5 C31.7,12.9,31.1,13.6,30.3,13.6C30.3,13.6,30.3,13.6,30.3,13.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M35.4,36.7V15.1H9.6v21.6H35.4z M13.9,17.2h17.2c0.5-0.1,0.9,0.3,1,0.8c0,0.1,0,0.1,0,0.2v15.4 c0,0.6-0.4,1-1,1H13.9c-0.5,0-1-0.5-1-1V18.2C12.9,17.7,13.3,17.2,13.9,17.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M12.9,18.2v15.4c0,0.5,0.5,1,1,1h17.2c0.6,0,1-0.4,1-1V18.2c0.1-0.5-0.3-0.9-0.8-1c-0.1,0-0.1,0-0.2,0H13.9 C13.3,17.2,12.9,17.7,12.9,18.2z M13.9,17.9h17.2c0.2,0,0.4,0.2,0.4,0.4v15.4c0,0.2-0.2,0.4-0.4,0.4H13.9c-0.2,0-0.3-0.2-0.3-0.4 V18.2C13.6,18,13.7,17.9,13.9,17.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M13.6,18.2v15.4c0,0.2,0.1,0.4,0.3,0.4h17.2c0.2,0,0.4-0.2,0.4-0.4V18.2c0-0.2-0.2-0.4-0.4-0.4H13.9 C13.7,17.9,13.6,18,13.6,18.2z M26.1,21c0,0.5-0.5,1-1,1h-5.2c-0.5-0.1-0.9-0.5-0.9-1v-0.2c0-0.5,0.4-0.9,0.9-1h5.2c0.5,0,1,0.5,1,1 L26.1,21z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M20,19.8h5.1c0.6,0,1,0.4,1,1v0.1c0,0.6-0.4,1-1,1H20c-0.6,0-1-0.4-1-1v-0.1C19,20.2,19.4,19.8,20,19.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M24.4,12.1c-0.1-1-0.9-1.8-1.9-1.9c-1,0.1-1.8,0.9-1.8,1.9c0,1,0.8,1.8,1.8,1.8l0,0 C23.5,14,24.3,13.2,24.4,12.1z M22.5,13.4c-0.7,0-1.2-0.5-1.2-1.2l0,0c-0.1-0.7,0.4-1.2,1.1-1.3c0,0,0.1,0,0.1,0 c0.7,0,1.3,0.6,1.3,1.3l0,0c0,0.7-0.5,1.2-1.2,1.2C22.6,13.4,22.5,13.4,22.5,13.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M23.8,12.1c0-0.7-0.6-1.3-1.3-1.3l0,0c-0.7,0-1.2,0.5-1.2,1.2c0,0,0,0.1,0,0.1c0,0.7,0.5,1.2,1.2,1.2l0,0 c0.7,0.1,1.2-0.4,1.3-1.1C23.8,12.2,23.8,12.2,23.8,12.1z M22.2,12.6v-0.9c0.1-0.1,0.2-0.2,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3 c0,0,0,0,0,0v0.9c0,0.2-0.1,0.3-0.3,0.3l0,0C22.3,12.9,22.2,12.7,22.2,12.6L22.2,12.6z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M31.7,12.1c0-0.8-0.6-1.4-1.4-1.5c-0.8,0-1.5,0.7-1.5,1.5c0.1,0.8,0.7,1.4,1.5,1.4 C31.1,13.6,31.7,12.9,31.7,12.1z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M28.1,12.1c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5S28.1,13,28.1,12.1z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M19.9,12.1c0-0.8-0.6-1.4-1.4-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.6,1.4,1.4,1.4c0,0,0.1,0,0.1,0 C19.3,13.6,19.9,12.9,19.9,12.1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#28B557",
  d: "M16.2,12.1c0-0.8-0.6-1.4-1.4-1.5c-0.8,0-1.5,0.7-1.5,1.5c0.1,0.8,0.7,1.4,1.5,1.4 C15.6,13.6,16.2,12.9,16.2,12.1z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.8,12.6v-0.9c0-0.2-0.1-0.3-0.3-0.3l0,0c-0.1,0.1-0.2,0.2-0.3,0.3v0.9c0,0.2,0.1,0.3,0.3,0.3l0,0 C22.7,12.9,22.8,12.7,22.8,12.6L22.8,12.6z"
});

function SvgAppliances(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliances);
export default __webpack_public_path__ + "static/media/appliances.d78168f531fb47999f9d15ead59d7d45.svg";
export { ForwardRef as ReactComponent };